import { render } from "./NotFound.vue?vue&type=template&id=4e27edca&scoped=true"
const script = {}

import "./NotFound.vue?vue&type=style&index=0&id=4e27edca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e27edca"]])

export default __exports__